<template>
  <v-card v-if="file">
    <v-card-text>
      <strong>Working on file:&#160;</strong>
      <FileZ :file="file" />
    </v-card-text>
  </v-card>
</template>

<script>
import FileZ from "@/components/link/FileZ";
export default {
  name: "FileWorking",
  props: ["file"],
  components: {
    FileZ
  }
};
</script>
